import { Card } from 'react-bootstrap';
import styled from 'styled-components';

export const CardTable = styled(Card)`
    border-radius: 16px;
`

export const Header = styled.div`
    align-items: center;
    justify-content: space-between;
    padding: 10px;
`

export const Icon = styled.div`
    display: flex;
    align-items: center;
    font-size: 24px;
    margin-right: 10px;
    height: 100%;
    margin-bottom: 3px;
`

export const Title = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    height: 100%;
`

